/* cg-mobile.js (Round 30, Oct 11 2026): phone-first polish. Loaded sitewide from snippets/card-description-clamp.liquid. */
(function () {
  'use strict';
  /* hours as published: Sun-Thu 8am-8pm, Fri-Sat 8am-9pm (Pacific) */
  function laNow() {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
    var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
    var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { d: days[o.weekday], m: (+o.hour % 24) * 60 + (+o.minute) };
  }
  function H() { return window.CG_HOURS || { open: [7, 7, 7, 7, 7, 7, 7], close: [20, 21, 21, 21, 21, 21, 21] }; } function closeAt(d) { return H().close[d] * 60; } function openAt(d) { return H().open[d] * 60; }
  function fmt(m) { var h = Math.floor(m / 60), ap = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12; return h + (m % 60 ? ':' + ('0' + m % 60).slice(-2) : '') + ' ' + ap; }
  function facts() {
    var h1 = document.querySelector('.cgm-hero h1'); if (!h1 || document.querySelector('.cgm-facts')) return;
    var n = laNow(), open = n.m >= openAt(n.d) && n.m < closeAt(n.d);
    var p = document.createElement('p'); p.className = 'cgm-facts';
    p.innerHTML = '<span class="' + (open ? 'is-open' : 'is-closed') + '"><i class="cgm-facts__dot"></i><b>' + (open ? 'Open now' : 'Closed') + '</b> · ' +
      (open ? 'until ' + fmt(closeAt(n.d)) : 'opens ' + fmt(n.m < openAt(n.d) ? openAt(n.d) : openAt((n.d + 1) % 7))) + '</span><span>★ <b>4.4</b> (2,100+)</span><span>Pickup in about 20 min</span>';
    h1.parentNode.insertBefore(p, h1.nextSibling);
  }
  /* the whole order row opens the pickup / delivery chooser, not just the small Change link */
  function rowTap() {
    var s = document.querySelector('.cgm-setup--native .cgm-setup__summary'); if (!s || s.dataset.cgTap) return; s.dataset.cgTap = '1';
    s.addEventListener('click', function (e) { if (e.target.closest('[data-cgm-setup-open]')) return; var b = s.querySelector('[data-cgm-setup-open]'); if (b) b.click(); });
  }
  /* native ordering: copy that still sends people to the Toast site or to a quote form */
  function copyFix() {
    if (!(window.CG_ENHANCE && window.CG_ENHANCE.native)) return;
    document.querySelectorAll('a').forEach(function (a) {
      if (a.dataset.cgCopy) return;
      var t = (a.textContent || '').trim();
      if (/order\.californiagrill\.com/i.test(t)) {
        a.dataset.cgCopy = '1';
        var prev = a.previousSibling;
        if (prev && prev.nodeType === 3) prev.textContent = prev.textContent.replace(/\s+at\s*$/, ' on ');
        a.textContent = 'our online menu'; a.setAttribute('href', '/pages/food-menu-new'); a.removeAttribute('target');
      } else if (/^get a catering quote$/i.test(t) || /^get a quote$/i.test(t)) {
        a.dataset.cgCopy = '1'; a.textContent = t === t.toUpperCase() ? 'ORDER CATERING' : 'Order catering';
        if (/quote/i.test(a.getAttribute('href') || '')) a.setAttribute('href', '/collections/catering');
      }
    });
  }
  function boot() { facts(); rowTap(); copyFix(); setTimeout(copyFix, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* Toast-style menu rows (Oct 11 2026). One tap does the obvious thing, like Toast / DoorDash / Uber Eats:
   - the round + on the photo adds a dish with no required choices straight to the order (no sheet)
   - dishes with required choices (sides, temp, sauce) still open the sheet
   - once a simple dish is in the order the + turns into a  - 1 +  stepper; dishes with choices show their count
   - tapping the row opens the dish sheet instead of leaving the menu for a product page */
(function () {
  'use strict';
  var root = document.querySelector('[data-cgm][data-order-mode="native"]');
  if (!root) return;
  var P = {};
  root.querySelectorAll('script[data-cgm-product]').forEach(function (s) { try { var p = JSON.parse(s.textContent); P[p.id] = p; } catch (e) {} });
  function simple(p) { return !!(p && p.available && p.variants && p.variants.length === 1 && !(p.groups || []).some(function (g) { return g.required; })); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (x) { if (!r.ok) throw new Error(x.description || x.message || 'Could not update your order'); return x; }); });
  }
  var tEl;
  function say(m) {
    if (!tEl) { tEl = document.createElement('div'); tEl.className = 'cgc cgc-toast'; document.body.appendChild(tEl); }
    tEl.textContent = m; tEl.classList.add('is-visible'); clearTimeout(tEl._t); tEl._t = setTimeout(function () { tEl.classList.remove('is-visible'); }, 1800);
  }
  function bubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var w = document.getElementById('cart-icon-bubble'); if (!w || !s['cart-icon-bubble']) return;
      var t = document.createElement('div'); t.innerHTML = s['cart-icon-bubble']; var i = t.querySelector('#cart-icon-bubble') || t; w.innerHTML = i.innerHTML;
    }).catch(function () {});
  }
  function attrs() { var m = window.CGMenu; if (m && m.attributes) post('/cart/update.js', { attributes: m.attributes() }).catch(function () {}); }
  function after() { var m = window.CGMenu; bubble(); return m && m.loadCart ? m.loadCart() : sync(); }
  function visibleProps(it) { return Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).length; }
  function paint(cart) {
    var by = {};
    (cart.items || []).forEach(function (it) { var b = by[it.product_id] || (by[it.product_id] = { q: 0, lines: [] }); b.q += it.quantity; b.lines.push(it); });
    root.querySelectorAll('.cgc-card[data-product-id]').forEach(function (card) {
      var pid = card.getAttribute('data-product-id'), p = P[pid], b = by[pid], btn = card.querySelector('button[data-cgm-add]');
      var old = card.querySelector('.cg-step'); if (old) old.remove();
      card.classList.remove('cg-has-step'); if (btn) { btn.classList.remove('cg-q'); btn.removeAttribute('data-q'); }
      if (!b || !btn) return;
      if (simple(p) && b.lines.length === 1 && !visibleProps(b.lines[0])) {
        var s = document.createElement('div'); s.className = 'cg-step';
        s.innerHTML = '<button type="button" data-k="' + b.lines[0].key + '" data-q="' + (b.q - 1) + '" aria-label="One less">' + (b.q > 1 ? '&minus;' : '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>') + '</button><span>' + b.q + '</span><button type="button" data-k="' + b.lines[0].key + '" data-q="' + (b.q + 1) + '" aria-label="One more">+</button>';
        card.appendChild(s); card.classList.add('cg-has-step');
      } else { btn.classList.add('cg-q'); btn.setAttribute('data-q', b.q); }
    });
  }
  function sync() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { paint(c); return c; }).catch(function () {}); }

  root.addEventListener('click', function (e) {
    var st = e.target.closest('.cg-step button');
    if (st) {
      e.preventDefault(); e.stopImmediatePropagation();
      var box = st.parentNode; box.setAttribute('aria-busy', 'true');
      post('/cart/change.js', { id: st.dataset.k, quantity: +st.dataset.q }).then(after).catch(function (x) { say(x.message); sync(); });
      return;
    }
    var add = e.target.closest('button[data-cgm-add]');
    if (add) {
      var p = P[add.dataset.cgmAdd];
      if (!simple(p)) return; /* cg-menu.js opens the sheet */
      e.preventDefault(); e.stopImmediatePropagation();
      if (add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      post('/cart/add.js', { items: [{ id: p.variants[0].id, quantity: 1, properties: {} }] })
        .then(function () { attrs(); say('Added · ' + p.title); return after(); })
        .catch(function (x) { say(x.message); })
        .then(function () { add.removeAttribute('aria-busy'); });
      return;
    }
    /* row tap: open the dish sheet, keep the product link for search engines and new-tab clicks */
    var card = e.target.closest('.cgc-card[data-product-id]');
    if (card && !e.metaKey && !e.ctrlKey && !e.shiftKey && window.CGMenu && window.CGMenu.openSheet) {
      var pp = P[card.getAttribute('data-product-id')];
      if (pp && pp.available) { e.preventDefault(); e.stopImmediatePropagation(); window.CGMenu.openSheet(pp); }
    }
  }, true);

  /* the menu's own add / remove / edit paths repaint the "in your order" tag; repaint the steppers after them */
  var tm = null;
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      var t = m[i].target; if (t.nodeType !== 1) t = t.parentNode;
      if (t && t.classList && t.classList.contains('cgc-card__incart')) { clearTimeout(tm); tm = setTimeout(sync, 120); return; }
    }
  }).observe(root, { childList: true, characterData: true, subtree: true });
  sync();

  /* dish sheet: special instructions open like Toast, with the house rule under it */
  var ts = null;
  new MutationObserver(function () {
    clearTimeout(ts); ts = setTimeout(function () {
      var d = document.querySelector('.cgm-sheet.is-open details.cgm-notes:not([data-cgo])'); if (!d) return;
      d.setAttribute('data-cgo', '1'); d.open = true;
      var o = d.querySelector('.cgc-opt'); if (o && !o.querySelector('.cg-adv')) { var a = document.createElement('p'); a.className = 'cg-adv'; a.textContent = 'No substitutions. Additions may be charged extra.'; o.appendChild(a); }
    }, 60);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
/* menu page: adding a dish keeps you on the menu (the order bar updates), like Toast. The side cart still opens
   from the cart icon and from "Review order". Everywhere else an add still opens the side cart. */
(function () {
  'use strict';
  if (!document.querySelector('[data-cgm][data-order-mode="native"]') || !window.fetch) return;
  var quietUntil = 0, of = window.fetch;
  var w = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = of.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) { quietUntil = Date.now() + 10000; p.then(function () { quietUntil = Date.now() + 1800; }, function () { quietUntil = 0; }); }
    return p;
  };
  Object.keys(of).forEach(function (k) { w[k] = of[k]; }); window.fetch = w;
  function patch() {
    var d = document.querySelector('cart-drawer'); if (!d || d.__cgQuiet || typeof d.open !== 'function') return;
    var open = d.open; d.__cgQuiet = true;
    d.open = function () { if (Date.now() < quietUntil) return; return open.apply(d, arguments); };
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patch);
  patch(); setTimeout(patch, 1500);
})();
